<template>
  <div class="query">
    ?
  </div>
</template>
<script>
export default {
  name: 'queryTipsIcon'
}
</script>
<style lang="less" scoped>
  .query {
    width: 20px;
    height: 20px;
    line-height: 17px;
    border-radius: 10px;
    text-align: center;
    border: 2px solid #C0C4CC;
    font-weight: 600;
    color: #C0C4CC;
    display: inline-block;
    margin: 5px;
    cursor: pointer;
  }
</style>
